import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({
            learn_more_active: false,
        });
    }

    render({ lists, code }) {
        const list = lists.filter(list => list.code === code)[0];

        let status = 'not-subscribed';
        if (list.subscribed) {
            status = list.intent ? 'unsubscribe' : 'subscribed';
        } else if (list.intent) {
            status = 'subscribe';
        }

        const list_button_class = 'email-button ' + status;

        const list_button_text = status.replace('-', ' ');

        const wrapper_class = list.subscribed || list.intent != list.subscribed
            ? 'checkbox-wrapper checked'
            : 'checkbox-wrapper';

        return (
            <member-email-preference-list class='row'>
                <div class='small-1 columns'>
                    <div class={wrapper_class} onClick={() => this.toggleListStatus(list)}>
                        <input
                          type='checkbox'
                          name={list.code}
                          value={list.subscribed}
                          checked={list.subscribed || list.intent}
                        />
                    </div>
                </div>
                <div class='small-7 medium-8 columns text-left'>
                    <h3>
                        {list.name}
                        <small><a href='#' onClick={(e) => this.toggleListLearnMore(list, e)}>Learn More</a></small>
                    </h3>
                </div>
                <div class='small-4 medium-3 columns'>
                    <a href='#' onClick={(e) => this.toggleListStatus(list, e)} class={list_button_class}>
                        <span>{list_button_text}</span>
                    </a>
                </div>
                <div class='small-11 small-offset-1 columns text-left'>
                    {this.renderListLearnMore(list)}
                </div>
            </member-email-preference-list>
        );
    }

    renderListLearnMore(list) {
        if (this.state.learn_more_active) {
            return (
                <p>{list.description}</p>
            );
        }

        return null;
    }

    toggleListStatus(list, e) {
        if (e) {
            e.preventDefault();
        }

        this.props.toggleIntention(list.code);
    }

    toggleListLearnMore(list, e) {
        e.preventDefault();

        this.setState({ learn_more_active: !this.state.learn_more_active });
    }
}

const mapStateToProps = (state) => ({
    lists: state['mail-lists'] && state['mail-lists'].lists,
});

const mapDispatchToProps = (dispatch) => ({
    toggleIntention: (code) => dispatch({ type: 'mail-lists:toggle_intention', payload: code}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);





// WEBPACK FOOTER //
// ./app/components/member/email-preference-list.js